import { Button, DatePicker, Modal } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { useInfoUser } from "../../../store/UserStore";
const MailScheduleModal = ({ onCancel, open, schedule, setSchedule }) => {
  const { languageMap } = useInfoUser();

  const [time, setTime] = useState("");

  const onConfirm = () => {
    setSchedule({ ...schedule, time, isUpdateScheduleTime: true });
    onCancel();
  };

  return (
    <Modal
      width={450}
      open={open}
      onCancel={() => {
        onCancel();
      }}
      footer={null}
      centered
      className="custom-confirm-modal"
      maskClosable={false}
    >
      <div className="modal-header">
        <div className="modal-title">Time schedule</div>
        <div className="modal-divider" />
      </div>

      <DatePicker
        value={time}
        onChange={(date) => setTime(date)}
        showNow={false}
        showTime={{ format: "HH:mm" }}
        // needConfirm={false}
        format="YYYY-MM-DD HH:mm"
        allowClear={false}
        onKeyDown={(e) => e.preventDefault()}
        className="w-[100%] mb-[5px]"
        minDate={dayjs()}
      />

      <div className="flex justify-end gap-2">
        <Button
          className="!bg-[#ffffff] !text-black hover:!bg-[#d9d9d9] font-medium"
          onClick={onCancel}
        >
          {languageMap?.["modal.cancel"] ?? "Không"}
        </Button>
        <Button
          className="!bg-[#ff4d4f] !text-white hover:!bg-[#ff7875] font-medium"
          onClick={onConfirm}
        >
          {languageMap?.["modal.ok"] ?? "OK"}
        </Button>
      </div>
    </Modal>
  );
};

export { MailScheduleModal };
